<template>
  <base-modal
    id="edit-widgets-modal"
    title="EDIT WIDGETS"
    :value="value"
    extra-class="modal-sm"
    @save="$emit('save', widgets)"
    @input="$emit('input', $event)"
  >
    <div class="form-group" v-for="widget in Object.keys(widgets)">
      <label class="mt-checkbox no-margin-bot" :for="widget + '-widget'">{{ widget }}
        <input type="checkbox"
               class="widget-enabled-checkbox"
               :id="widget + '-widget'"
               :value="widget"
               v-model="widgets[widget]"
        />
        <span></span>
      </label>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from "./BaseModal";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    widgets: {
      type: Object,
      required: true
    }
  },
  components: {BaseModal},
  emits: ['save', 'input'],
}
</script>



// WEBPACK FOOTER //
// EditWidgetsModal.vue?3c674d75